module.exports = __webpack_public_path__ + "static/media/ipadgrafik.ed9a86e7.svg";